export default {
  headings: [
    { text: "Goalkeepers: Neglected tropical diseases (NTDs)" },
    { text: "Goalkeepers: HIV" },
    { text: "Goalkeepers: Malaria" },
    { text: "Countries with malaria transmission", highlight: [2, 3] },
    { text: "We are looking at introducing some key new tools" },
    { text: "Which will mean we can achieve this scenario by 2040…" },
    { text: "But delaying just one of these tools could mean…" },
    { text: "…it takes more than a decade longer to eradicate malaria" },
  ],
  intro: {
    strapline: "Progress is possible, but not inevitable",
  },
};



// WEBPACK FOOTER //
// ./src/data/states.js